import React from 'react';

const DocumentSection = ({ 
    title, 
    action,
    children 
}) => (
    <div className="dm-section mb-2">
        <div className="dm-header">
            <h6 className="dm-subtitle">{title}</h6>
            {action}
        </div>
        {children}
    </div>
);

export default DocumentSection;